export default {"src":"/_next/static/media/address-left.0795d9a1.svg","height":2,"width":197,"blurWidth":0,"blurHeight":0};